import { WishlistElementHeadless } from "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.25.18/wishlist-element-headless.js";

export const icons = {
  wishlist: `
    <svg viewBox="0 0 64 64">
      <path d="M32.012,59.616c-1.119-.521-2.365-1.141-3.707-1.859a79.264,79.264,0,0,1-11.694-7.614C6.316,42,.266,32.6.254,22.076,0.244,12.358,7.871,4.506,17.232,4.5a16.661,16.661,0,0,1,11.891,4.99l2.837,2.889,2.827-2.9a16.639,16.639,0,0,1,11.874-5.02h0c9.368-.01,17.008,7.815,17.021,17.539,0.015,10.533-6.022,19.96-16.312,28.128a79.314,79.314,0,0,1-11.661,7.63C34.369,58.472,33.127,59.094,32.012,59.616Z"/>
    </svg>
  `,
  remove: `
    <svg viewBox="0 0 64 64">
      <path d="M0.309,0.309a0.9,0.9,0,0,1,1.268,0L63.691,62.423a0.9,0.9,0,0,1-1.268,1.268L0.309,1.577A0.9,0.9,0,0,1,.309.309Z"/>
      <path d="M63.691,0.309a0.9,0.9,0,0,1,0,1.268L1.577,63.691A0.9,0.9,0,0,1,.309,62.423L62.423,0.309A0.9,0.9,0,0,1,63.691.309Z"/>
    </svg>
  `,
  share: `
    <svg viewBox="0 0 24 24">
      <path d="M20 13v6a2 2 0 01-2 2H6a2 2 0 01-2-2v-6M12 15V3m0 0L8.5 6.5M12 3l3.5 3.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `,
  buy: `
    <svg viewBox="0 0 24 24">
      <path d="M19.26 9.696l1.385 9A2 2 0 0118.67 21H5.33a2 2 0 01-1.977-2.304l1.385-9A2 2 0 016.716 8h10.568a2 2 0 011.977 1.696zM14 5a2 2 0 10-4 0" fill="none" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `,
  spinner: `
    <svg class="wk-spinner-svg" viewBox="0 0 66 66">
      <circle class="wk-spinner-circle" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>
  `,
  caret: `
    <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24">
      <path d="M6 9l6 6 6-6" />
    </svg>
  `,
};

window.headlessElements.define(
  "wishlist-button-headless",
  class WishlistButtonHeadless extends WishlistElementHeadless {
    getStateConfig() {
      return {
        productInfo: true,
      };
    }

    getEventConfig() {
      return {
        click: this.handleClick,
      };
    }

    handleClick() {
      if (this.productInfo.inWishlist) {
        return this.app.removeWishlistItem(this.productInfo);
      } else {
        return this.app.addWishlistItem(this.productInfo);
      }
    }

    updated() {
      this.host.classList.toggle("wk-selected", this.productInfo.inWishlist);

      const textElement = this.host.querySelector(".wk-text");
      textElement.innerText = this.getText();
    }

    getText() {
      if (this.productInfo.inWishlist) {
        return "Remove from Wishlist";
      }
      return "Add to Wishlist";
    }
  },
);

window.headlessElements.define(
  "wishlist-link-headless",
  class WishlistLinkHeadless extends WishlistElementHeadless {
    getStateConfig() {
      return {
        wishlist: true,
      };
    }

    getWishlistUrl() {
      if (this.app.settings.loginRequired) {
        return this.app.routes.accountLoginUrl;
      }
      return this.app.routes.wishlistUrl;
    }

    updated() {
      const numItems = this.wishlist ? this.wishlist.numItems : 0;

      this.host.href = this.getWishlistUrl();
      this.host.classList.toggle("wk-selected", numItems > 0);
      this.host.querySelector(".wk-counter").innerText = numItems;
    }
  },
);
